import { __rest } from 'tslib';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { isMobile, Divider, styled } from '@teko/ds-desktop';
import { g as getImageUrlFromGoogleUserContent } from './image-b1bfb7c2.js';
import { B as BlockHeader } from './BlockHeader-4332d564.js';
import { P as ProductCarousel } from './ProductCarousel-be468b91.js';

const ProductCarouselWithHeader = (_a) => {
    var { header, background, dividerColor = 'rgba(255, 255, 255, 0.5)' } = _a, productCarouselProps = __rest(_a, ["header", "background", "dividerColor"]);
    return (jsxs(Wrapper, Object.assign({ style: {
            minHeight: isMobile ? 'auto' : 416,
        }, background: getImageUrlFromGoogleUserContent(background, {
            width: 1232,
        }) }, { children: [header && (jsxs(Fragment, { children: [jsx(BlockHeader, Object.assign({}, header), void 0), jsx(Divider, { gap: 0, color: dividerColor }, void 0)] }, void 0)), jsx(StyledProductCarousel, Object.assign({}, productCarouselProps), void 0)] }), void 0));
};
const Wrapper = styled.div `
  ${(props) => props.background && `background-image: url(${props.background});`}
  border-radius: 8px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  min-height: 416px;
`;
const StyledProductCarousel = styled(ProductCarousel) `
  padding: 12px;
`;

export { ProductCarouselWithHeader as P };
